import { useState } from 'react'

import { ColorPickerField as Field } from '../../../ColorPicker'
import { Component, ComponentProps } from '../../Component'
import { controls, text } from '../../Controls'

export function ColorPickerField() {
  const [props, setProps] = useState(() =>
    controls().add(text('color', '#FF0000'))
  )

  function handleChange(nextValue) {
    setProps(currProps => currProps.setValue('value', nextValue))
  }

  return (
    <>
      <Component
        {...props.getValues()}
        Component={Field}
        name='ColorPickerField'
        onChange={handleChange}
      />
      <ComponentProps
        name='ColorPickerField'
        value={props}
        onChange={setProps}
      />
    </>
  )
}

export default ColorPickerField
